import { render } from "./ListUndergraduate.vue?vue&type=template&id=3cf8d897&scoped=true"
import script from "./ListUndergraduate.vue?vue&type=script&lang=js"
export * from "./ListUndergraduate.vue?vue&type=script&lang=js"

import "./ListUndergraduate.vue?vue&type=style&index=0&id=3cf8d897&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf8d897"]])

export default __exports__